// extracted by mini-css-extract-plugin
export default {"Distribution":"PieChartDistribution_Distribution__hJCNt","container":"PieChartDistribution_container__yHrnj"};